const fileUrl = (dataId: string): string =>
  `${process.env.REACT_APP_API_URL}/api/file/${dataId}`;

export const downloadFileUrl = (dataId: string): string =>
  `${process.env.REACT_APP_API_URL}/api/file/${dataId}/download`;

export default fileUrl;
